import { Dog } from './dog';
import { inherits } from 'util';
import { extend } from 'webdriver-js-extender';

export class GirlDog extends Dog {
    id = 0;
}
